import React from "react";
import { Heading } from "@tennr/frontend/components/Heading";
import { DynamicText } from "@tennr/frontend/components/DynamicText";
import "./AboutBeliefsSection.css";

export interface AboutBeliefItemProps {
  number: string;
  title: string;
  description: string;
}

export const AboutBeliefItem: React.FC<AboutBeliefItemProps> = ({ number, title, description }) => {
  return (
    <div className="about-belief-item">
      <div className="about-belief-item__number">{number}</div>
      <p className="about-belief-item__title">{title}</p>
      <p className="about-belief-item__description">{description}</p>
    </div>
  );
};

export interface AboutBeliefsSectionProps {
  className?: string;
}

export const AboutBeliefsSection: React.FC<AboutBeliefsSectionProps> = ({ className = "" }) => {
  const beliefs = [
    {
      number: "NUMBER 1",
      title: "We believe no referral should ever fall through the cracks.",
      description:
        "Every patient referral is an opportunity to serve—and an obligation to follow up. We've built a platform that ensures nothing falls into the black hole of the U.S. healthcare system, so practices can grow efficiently, patients get better care, and referrers get true visibility into the status of their patients.",
    },
    {
      number: "NUMBER 2",
      title:
        "We believe healthcare technology companies need to meet providers where they're at—faxing isn't the problem.",
      description:
        "We believe this so strongly, we hired professional actors to make the point for us. Providers are drowning in piles of messy documents, ever-changing payor guidelines, and 45 minute phone tree wait times. We meet providers where they're at, integrating with receiving providers' EHRs and letting referrers fax away (yep, our models even handle checkboxes and messy handwriting).",
    },
    {
      number: "NUMBER 3",
      title: 'We believe in \"AI\" transparency',
      description:
        "We're tired of software companies hand-waving the term \“AI\” to mask their shortcomings. We built our own machine learning models and provide transparency into how they're trained, how they benchmark and what they do. It's not just about 'automating' it's about making sure every patient is taken care of like your best teammate was on the case.",
    },
  ];

  return (
    <section className={`about-beliefs-section ${className}`}>
      <div className="about-beliefs-section__container">
        <Heading
          title="ABOUT US"
          heading="Things we believe"
          body="Solving the pre-visit patient processing problem will massively reduce patient delays and denials across the U.S. healthcare system. And the problem is completely solvable."
          position="center"
          color="dark"
          variant="hero"
          className="about-beliefs-section__header"
        />

        <div className="about-beliefs-section__beliefs">
          {beliefs.map((belief, index) => (
            <Heading
              key={index}
              title={belief.number}
              heading={belief.title}
              body={belief.description}
              position="left"
              color="dark"
              variant="tertiary"
              className="about-belief-item"
            />
          ))}
        </div>

        <DynamicText as="div" className="about-beliefs-section__signature">
          – The Tennr Team
        </DynamicText>
      </div>
    </section>
  );
};
